import StarIcon from '@/components/atoms/starIcon'
import { useMediaQuery } from '@mui/material'
import Link from 'next/link'

const MenuItemButton = ({ name, link, active = false, ...args }) => {
  const base = `text-displayMobile md:text-[64px] font-ttDrugsTrial uppercase flex flex-col items-center gap-y-[20px] hover:text-olive group transition-all duration-500 ${
    active ? 'text-olive pointer-events-none' : 'text-khaki'
  }`
  return (
    <Link scroll={false} href={link} className={base} {...args}>
      {!useMediaQuery('(max-width: 767px)') && (
        <StarIcon className={`${!active ? 'opacity-0' : ''}`} />
      )}
      {name}
    </Link>
  )
}

export default MenuItemButton
